import React from 'react'
import { forwardRef } from 'react'
import { CafeItemsReport, CourseTable, CoursesReportData, ExpenseData, ReceptionsReportData, SalaryReportData, SupplementsReportData, Table } from './MonthlyReportScreen'
import i18next from 'i18next'

const PrintMonthlyReportData = forwardRef(({ data, expenses, dollarPrice, }, ref) => {
    const language = i18next.language

    return (
        <div style={{ height: '100%' }} ref={ref} className='flex flex-col w-full h-full' >
            <div style={{ direction: language === 'en' ? 'ltr' : 'rtl' }} className="flex flex-col flex-wrap items-center w-full mt-12 justify-evenly">

                {<Table data={data} isFromPrint dollarPrice={dollarPrice} />}

                <div className='flex flex-col items-center w-full' >
                    <CoursesReportData isFromPrint data={data[0].akafitness.data[0].data.revenue.courses} />
                    <ReceptionsReportData isFromPrint data={data[0].akafitness.data[0].data.revenue.memberships.receptions} />
                    <SalaryReportData isFromPrint courses={data[0].akafitness.data[0].data.revenue.courses} receptions={data[0].akafitness.data[0].data.revenue.memberships.receptions} supplements={data[0].akafitness.data[0].data.revenue.supplements} data={data[0].akafitness.data[0].data.salaries} />
                    <CafeItemsReport isFromPrint={true} centerId={data[0].akafitness.data[0].centerId} duration={{startDate:data[0].date.start_date,endDate:data[0].date.end_date}} />

                    {expenses && <ExpenseData isFromPrint expensesData={expenses} />}

                </div>

            </div>
        </div>
    )
})

export default PrintMonthlyReportData
